// Client realtime (Pusher). Prefer Parameter Store / build-time injection for
// server secrets; these public client keys are expected in the SPA bundle.
export const SOCKETIO_URL = "pusher.com";
export const PUSHER_KEY = 'cf41d68709e66c0e645b';
export const PUSHER_REGION = 'mt1';
export const PUSHER_APP = 'autokorea-aws';
export const PUSHER_APP_SECRET = '8f0e335a0dfb69d95dbf';
export const PUSHER_CHANNEL = 'autokorea-aws';
export const PUSHER_ID = '1861355';

// ---------------------------------------------------------------------------
// API_URL — only ONE active export at a time.
// Local:     http://127.0.0.1:8000  → npm run serve
// AWS prod:  https://wapsystem-api.akerp.co.za → npm run build → S3 + CloudFront
// Do NOT use `npm run serve` for production (legacy Azure pattern).
// See docs/aws-architecture.md and docs/aws-local-prep.md
// ---------------------------------------------------------------------------
// export const API_URL = "https://api.aksystem.co.za"; // Legacy production
// export const API_URL = "https://api.akss.co.za"; // Legacy AWS production
// export const API_URL = "https://wapsystem-api.akerp.co.za"; // Target AWS (Madagascar)
// export const API_URL = "http://localhost:8000"; // Local API (Docker nginx → php-fpm)
// export const API_URL = "https://laravel-app-staging-alb-482715977.af-south-1.elb.amazonaws.com"; // AWS staging ALB raw
export const API_URL = "https://wap-api.autokorea.co.za"; // AWS staging custom domain
// export const API_URL = "https://ak-api.sinappsus.online"; // Sinapsus Dev Server

// Website QR on inventory barcode labels (printAssistant2). Live wap-system hardcodes this.
export const QR_REDIRECT_URL = "http://redirectlink.co.za";

